import React from 'react'
import { Link } from 'react-router-dom/cjs/react-router-dom.min'

export const Logo = () => {
  return (
    <Link className="" to="/">
    <img alt="logo" className="xl:w-[100px] lg:w-[100px] w-[60px]" src="https://storage.googleapis.com/msgsndr/WMxXuC6fHRgjW2CA2lRt/media/6764357863c0fe2861d8f355.png" />
  </Link>
  )
}
